<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'

import { KanbanLogItemInfo } from '@widgets/kanban-comments'
import { AppText } from '@shared/ui/typography'

import { useTutorKanbanLogStageDetails } from '../../model/use-tutor-kanban-log-stage-details.hook'

defineOptions({
  name: 'TutorKanbanLogStageDetails',
})

const props = defineProps<{
  actor: KanbanLogActor | null
  oldValue: string
  value: string
}>()

const {
  refLabel,
  refReasons,
  refCategories,
} = useTutorKanbanLogStageDetails({
  actor: props.actor,
  oldValue: props.oldValue,
  value: props.value,
})
</script>

<template>
  <div class="kanban-log-field">
    <KanbanLogItemInfo
      :actor="actor"
      :label="refLabel"
    />
    <div
      v-if="refReasons || refCategories"
      class="tutor-kanban-log-stage-details"
    >
      <div
        v-if="refReasons"
        class="tutor-kanban-log-stage-details__row"
      >
        <AppText
          name="body2-medium"
          color="slate-500"
        >
          Reasons:
        </AppText>
        <AppText
          name="body2"
          color="slate-900"
        >
          {{ refReasons }}
        </AppText>
      </div>
      <div
        v-if="refCategories"
        class="tutor-kanban-log-stage-details__row"
      >
        <AppText
          name="body2-medium"
          color="slate-500"
        >
          Categories:
        </AppText>
        <AppText
          name="body2"
          color="slate-900"
        >
          {{ refCategories }}
        </AppText>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@shared/ui/kanban/styles/_kanban-log-field.scss" />
